/** Grymwyrd — polska kopija wspólnych stron systemowych (błędy, 404, prawo). */
export const systemPl = {
  // LegalPage
  'system.legal.fallbackTitle': 'Dokument',
  'system.legal.fallbackBody': 'Nie znaleziono.',
  'system.legal.lastUpdated': 'Ostatnia aktualizacja {date}',

  // NotFoundPage
  'system.notFound.seoTitle': 'Zagubiony w Zasłonie',
  'system.notFound.heading': 'Błądziłeś poza granicą mapy',
  'system.notFound.body': 'Ścieżka, którą szukałeś, pochłonęła wieczna półmrok.',
  'system.notFound.returnCta': 'Powróć do Zasłony',

  // RouteErrorBoundary
  'system.error.unknownDisturbance': 'Nieznane zaburzenie wstrząsnęło zasłoną.',
  'system.error.seoTitle': 'Zaburzenie w Zasłonie',
  'system.error.heading': 'Rytuat zawiódł',
  'system.error.body':
    'Coś nieprzewidzianego przerwało tę stronę. Zasłona jest tu cienka — spróbuj ponownie lub wróć do bezpieczniejszych miejsc.',
  'system.error.tryAgain': 'Spróbuj Ponownie',
  'system.error.returnCta': 'Powróć do Zasłony',
  'licenseGate.heading': "Wkrótce — ograniczenia licencyjne",
  'licenseGate.body': "Ta wersja językowa nie jest jeszcze dostępna z powodów licencyjnych. Już nadchodzi — zajrzyj wkrótce.",
} as const
